import { useMemo } from 'react';
import { useUserSettings } from '../modules/settings/useData';
import { getBrowserTimeZone, resolveDisplayTimeZone, formatTimeZoneLabel } from '../utils/timeZone';

export function useDisplayTimeZone(): string | undefined {
  const { userSettings } = useUserSettings();
  return useMemo(
    () => resolveDisplayTimeZone(userSettings?.displayTimeZone),
    [userSettings?.displayTimeZone],
  );
}

/** Active zone used for formatting (preference or browser). */
export function useEffectiveDisplayTimeZone(): string {
  const preference = useDisplayTimeZone();
  return preference ?? getBrowserTimeZone();
}

export function useDisplayTimeZoneCaption(): string {
  const preference = useDisplayTimeZone();
  const browser = getBrowserTimeZone();
  if (preference) {
    return preference === browser
      ? `Your time (${formatTimeZoneLabel(preference)})`
      : `Shown in ${formatTimeZoneLabel(preference)}`;
  }
  return `Your local time (${formatTimeZoneLabel(browser)})`;
}
